'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Jumbotron = require('react-bootstrap/lib/Jumbotron');

var _Jumbotron2 = _interopRequireDefault(_Jumbotron);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Jumbotron2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Jumbotron.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Jumbotron.js
 ** module chunks = 0
 **/